var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 10.5,
    viewBox: "0 0 10.5 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus",
    d: "M10.281-5.906a.193.193,0,0,1,.219.219v.875a.193.193,0,0,1-.219.219H5.906V-.219A.193.193,0,0,1,5.688,0H4.813a.193.193,0,0,1-.219-.219V-4.594H.219A.193.193,0,0,1,0-4.812v-.875a.193.193,0,0,1,.219-.219H4.594v-4.375a.193.193,0,0,1,.219-.219h.875a.193.193,0,0,1,.219.219v4.375Z",
    transform: "translate(0 10.5)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.882df44e74823989a24f44a2c0a92f25.svg";
export { ForwardRef as ReactComponent };